import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CollaborationGraphSingleSite } from './collaboration-graph-single-site';
import { CollaborationGraphMultiSite } from './collaboration-graph-multi-site';
export const MAX_CG_RESULTS = 10;
export const CONTEXT_USER_ID = 'context';
export const QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT = 'quickSearch';
export class CollaborationGraphClient {
  constructor(config) {
    _defineProperty(this, "getContainers", (containerTypes, sites = []) => {
      if (this.isMultiSite) {
        return this.collabGraphMultiSite.getContainers({
          selectedSites: sites,
          containerTypes,
          allSites: this.sites.length > 0 ? this.sites : [{
            cloudId: this.cloudId
          }]
        });
      } else {
        return this.collabGraphSingleSite.getContainers({
          containerTypes,
          cloudId: this.cloudId
        });
      }
    });
    _defineProperty(this, "getUsers", (sites = []) => {
      if (this.isMultiSite) {
        return this.collabGraphMultiSite.getUsers({
          allSites: this.sites.length > 0 ? this.sites : [{
            cloudId: this.cloudId
          }],
          selectedSites: sites
        });
      } else {
        return this.collabGraphSingleSite.getUsers({
          cloudId: this.cloudId
        });
      }
    });
    this.collabGraphSingleSite = new CollaborationGraphSingleSite(config);
    this.collabGraphMultiSite = new CollaborationGraphMultiSite(config);
    this.isMultiSite = config.isMultiSite;
    this.cloudId = config.cloudId;
    this.sites = config.sites;
  }
}